import Vue from 'vue'
import Router from 'vue-router'
import VueWaypoint from 'vue-waypoint'
import Meta from 'vue-meta'
import BasePageLayout from 'RuterShared/views/BasePageLayout.vue'

Vue.use(Router)
Vue.use(Meta)
Vue.use(VueWaypoint)

const router = new Router({
	mode: 'history',
	base: '/',
	routes: [
		{
			path: '/no',
			props: { lang: 'no' },
			component: BasePageLayout,
			children: [
				{
					name: 'no-home',
					path: '/',
					component: () => import('./views/FlexibleContentBase.vue'),
					props: {
						lang: 'no',
						postType: 'page',
						slug: 'forside'
					}
				},
				{
					name: 'no-downloads',
					path: 'nedlastinger',
					component: () => import(/* webpackMode: "lazy" */ 'RuterShared/views/DownloadCenter.vue'),
					props: { 
						lang: 'no',
						postType: 'page',
						slug: 'nedlastinger'
					}
				},
				{
					name: 'no-search',
					path: 'sok',
					component: () => import(/* webpackMode: "lazy" */ 'RuterShared/views/Search.vue'),
					props: { 
						lang: 'no',
						postType: 'page',
						slug: 'sok'
					}
				},
				{
					name: 'no-note',
					path: 'ruters-okonomi/noter/:note',
					component: () => import('./views/FlexibleContentBase.vue'),
					props: { 
						lang: 'no', 
						postType: 'article',
						chapters: 'ruters-okonomi',
						slug: 'noter',
					}
				},
				{
					name: 'no-article',
					path: ':chapter/:slug',
					component: () => import('./views/FlexibleContentBase.vue'),
					props: { 
						lang: 'no', 
						postType: 'article'
					}
				},
				{
					name: 'no-page-redirect',
					path: 'no',
					redirect: {
						path: '/no'
					},
					props: {
						lang: 'no',
						postType: 'page',
						slug: 'forside'
					}
				},
				{
					name: 'no-page',
					path: ':slug',
					component: () => import('./views/FlexibleContentBase.vue'),
					props: { 
						lang: 'no',
						postType: 'page'
					}
				}
			]
		},
		{
			path: '/en',
			props: { lang: 'en' },
			component: BasePageLayout,
			children: [
				{
					name: 'en-home',
					path: '/',
					component: () => import('./views/FlexibleContentBase.vue'),
					props: {
						lang: 'en',
						postType: 'page',
						slug: 'home'
					}
				},
				/*
				{
					name: 'en-intro',
					path: 'intro',
					component: () => import('./views/FlexibleContentBase.vue'),
					props: {
						lang: 'en',
						postType: 'page',
						slug: 'intro'
					}
				},
				{
					name: 'en-downloads',
					path: 'downloads',
					component: () => import('./views/DownloadCenter.vue'),
					props: {
						lang: 'en',
						postType: 'page',
						slug: 'downloads'
					}
				},
				{
					name: 'en-article',
					path: ':chapter/:slug',
					component: () => import('./views/FlexibleContentBase.vue'),
					props: {
						lang: 'en',
						postType: 'article'
					}
				},
				*/
				{
					name: 'en-page',
					path: ':slug',
					component: () => import('./views/FlexibleContentBase.vue'),
					props: {
						lang: 'en',
						postType: 'page'
					}
				},
			]
		},
		{
			path: '/graph/:id',
			name: 'single-graph',
			component: () => import(/* webpackMode: "lazy" */ 'RuterShared/views/SingleGraph.vue')
		}
	],

	// Prevents window from scrolling back to top
	// when navigating between components/views
	scrollBehavior () {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve({ x: 0, y: 0 })
			}, 500)
		})
	}
});

router.beforeEach(( to, from, next ) => {
	next()
});

export default router;